var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M89.691 46.814L60.077 17.199a4.455 4.455 0 00-3.174-1.31 4.457 4.457 0 00-3.174 1.31l-2.689 2.69a4.455 4.455 0 00-1.31 3.173c0 1.2.466 2.366 1.31 3.21l17.277 17.315H13.428c-2.475 0-4.43 1.937-4.43 4.413v3.802c0 2.476 1.955 4.608 4.43 4.608h55.085L51.041 73.822a4.39 4.39 0 00-1.31 3.144c0 1.2.465 2.313 1.31 3.158l2.689 2.68a4.451 4.451 0 003.174 1.307 4.457 4.457 0 003.173-1.312l29.615-29.615a4.458 4.458 0 001.31-3.183 4.457 4.457 0 00-1.31-3.187z"
  })));
};
export default SvgArrowRight;